import { Q as r, R as a } from "../../vendor-CPVnY93G.js";
import { useMemo as m } from "react";
import { isEqual as i } from "./isEqual.js";
function n(t) {
  const e = r(t ?? {}, i), { locale: o } = a();
  return m(() => new Intl.RelativeTimeFormat(o, e), [o, e]);
}
export {
  n as useRelativeTimeFormatter
};
